const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLines = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50002 17.867C3.50002 17.2755 3.97956 16.796 4.57111 16.796H19.4621C20.0536 16.796 20.5331 17.2755 20.5331 17.867C20.5331 18.4586 20.0536 18.9381 19.4621 18.9381H4.57111C3.97956 18.9381 3.50002 18.4586 3.50002 17.867Z",
    fill: "currentColor",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 11.9761C3.5 11.3846 3.97954 10.905 4.57108 10.905H19.4621C20.0536 10.905 20.5331 11.3846 20.5331 11.9761C20.5331 12.5676 20.0536 13.0472 19.4621 13.0472H4.57108C3.97954 13.0472 3.5 12.5676 3.5 11.9761Z",
    fill: "currentColor",
    style: {
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54894 6.08515C3.54894 5.49361 4.02848 5.01407 4.62002 5.01407H19.4621C20.0536 5.01407 20.5331 5.49361 20.5331 6.08515C20.5331 6.67669 20.0536 7.15623 19.4621 7.15623H4.62002C4.02848 7.15623 3.54894 6.67669 3.54894 6.08515Z",
    fill: "currentColor",
    style: {
      fillOpacity: 1
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLines);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Lines.b5bc956baab9f8beb270ee806d23e83a.svg";